import './style.css';

import { View } from '@zinc/ui';
import Button from 'bz-core-controls/controls/general/button';
import FlatButton from 'bz-core-controls/controls/general/flatButton';
import Modal from 'bz-core-controls/modal';
import camelCase from 'camelcase';
import { action, computed } from 'mobx';
import { observer } from 'mobx-react';
import React from 'react';
import { EditorState, Entity, RichUtils } from 'tm2-draft-js';
import Dialog from 'tm3-core/controls/modal/core-dialog';
import { v4 as uuid } from 'uuid';
import ControlAttributes from './panels/control';
import GroupAttributes from './panels/group';

@observer
class Properties extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  UNSAFE_componentWillReceiveProps(props) {
    let { store } = props;
    if (!(store.control > 0)) return;
    let entity = Entity.get(store.control);

    this.setState({
      type: entity.getType(),
      attributes: entity.getData(),
      validationItems: {}
    });
  }

  @computed
  get Invalid() {
    let { attributes, validationItems, type } = this.state;

    if (!Object.values(validationItems).every((v) => v)) return true;

    let invalid = false;

    let { label, required } = attributes;
    if (type.startsWith('Control')) {
      invalid = required === true && (label || '').trim() === '';
    } else if (type === 'Group') {
      invalid = !(!!attributes.field && !!attributes.operator && !!attributes.operatorValue);
    }

    return invalid;
  }

  @action
  onCancel(e) {
    if (e.preventDefault) {
      e.preventDefault();
    }

    let { store } = this.props;
    let { editor, control } = store;

    if (store.created) {
      let i = Entity.get(store.control).getType().startsWith('Group') ? 5 : 1;
      for (let x = 0; x < i; x++) {
        editor = EditorState.undo(editor);
      }
    }

    let filter = (x) => {
      return x.entity === control;
    };

    let content = editor.getCurrentContent();
    let selection = editor.getSelection();

    let block = content.getBlockForKey(selection.getStartKey());
    block.findEntityRanges(filter, (start, end) => {
      // selection = selection.merge({anchorOffset: start, focusOffset: end})
      // editor = EditorState.acceptSelection(editor, selection)
      // editor = RichUtils.toggleInlineStyle(editor, 'REFRESH')
      selection = selection.merge({ anchorOffset: end + 1, focusOffset: end + 1 });
      editor = EditorState.acceptSelection(editor, selection);
    });

    store.editor = editor;
    store.control = null;
    store.created = false;
    setTimeout(() => {
      this.props.onFocus();
    }, 100);
  }

  @action
  onApply(e) {
    if (e.preventDefault) e.preventDefault();
    let { store } = this.props;
    let { attributes } = this.state;
    let { editor, control } = store;
    let { field, label = '' } = attributes;

    if (field === -1 || field.length == 0) {
      let name = camelCase(label);

      let t = store.type;

      if (t === 'D' || t === 'U' || t === 'I') {
        t = 'C';
      }

      const psfs = 'ispsfs' in attributes ? '.psfs' : '';

      attributes.field = !!t ? `${t}.data.${name}-${uuid()}` : name;
      attributes.field += psfs;
    }

    Entity.mergeData(control, attributes);

    let filter = (x) => {
      return x.entity === control;
    };

    let content = editor.getCurrentContent();
    let selection = editor.getSelection();

    let block = content.getBlockForKey(selection.getStartKey());
    block.findEntityRanges(filter, (start, end) => {
      selection = selection.merge({ anchorOffset: start, focusOffset: end });
      editor = EditorState.acceptSelection(editor, selection);
      editor = RichUtils.toggleInlineStyle(editor, 'REFRESH');
      selection = selection.merge({ anchorOffset: end + 1, focusOffset: end + 1 });
      editor = EditorState.acceptSelection(editor, selection);
    });
    store.editor = editor;
    store.control = null;
    store.created = false;
    store.updateTemplate();
    this.props.onFocus();
  }

  isValid(key, valid) {
    let validationItems = { ...this.state.validationItems };
    validationItems[key] = valid;
    this.setState({ validationItems: validationItems });
  }

  onChange(key, val) {
    let attributes = { ...this.state.attributes };
    attributes[key] = val;
    // Interim solution until Maitland and Lookups can work side by side in harmony.
    // See http://issues.tm2app.local/issue/TM3-4135
    if (
      (key === 'src' && attributes['maitland']) ||
      (key === 'maitland' && attributes['src'] && attributes['src'].length > 0)
    ) {
      let thisun = key == 'src' ? 'the Custom List attribute' : 'the Maitland attribute';
      let thatun = key == 'src' ? 'the Maitland attribute' : 'the Custom List attribute';
      let modal = {
        title: 'Warning',
        description: `Enabling ${thisun} will disable ${thatun}. Do you wish to continue?`
      };
      Modal.confirmation(modal).then(() => {
        key == 'src' ? (attributes['maitland'] = false) : (attributes['src'] = null);
        this.setState({ attributes: attributes });
      });
    } else {
      this.setState({ attributes: attributes });
    }
  }

  onMultiChange(obj) {
    this.setState({ attributes: { ...this.state.attributes, ...obj } });
  }

  render() {
    let { type } = this.state;
    let { store } = this.props;
    let { control } = store;
    let attrs;

    if (!(control > 0)) {
      return <span />;
    }
    let { attributes } = this.state;
    if (type.startsWith('Control')) {
      attrs = (
        <ControlAttributes
          type={type.substring(8)}
          attributes={attributes}
          store={store}
          isValid={this.isValid.bind(this)}
          onChange={this.onChange.bind(this)}
        />
      );
    }
    if (type === 'Group') {
      attrs = (
        <GroupAttributes
          {...attributes}
          store={store}
          isValid={this.isValid.bind(this)}
          onChange={this.onChange.bind(this)}
          onMultiChange={this.onMultiChange.bind(this)}
        />
      );
    }

    return (
      <Dialog
        position="start"
        open={control != null}
        onCloseDialog={this.onCancel.bind(this)}
        title="Setup Properties"
        dialogWidth="450px"
        actions={[
          <FlatButton onClick={this.onCancel.bind(this)}>Cancel</FlatButton>,
          <Button disabled={this.Invalid} onClick={this.onApply.bind(this)}>
            Apply
          </Button>
        ]}
      >
        <View gap={2}>{attrs}</View>
      </Dialog>
    );
  }
}

Properties.defaultProps = {
  onFocus: () => {}
};

export default Properties;

export const { defaultProps } = Properties;
